(function () {
  var UMBRAL_ENVIO = 6990000; // $69.900 en centavos
  var PRODUCT_HANDLE = 'fragancia-ambiente-shalem-marketing-olfativo';
  var LS_WISHLIST = 'shalem_wishlist';

  function formatoCOP(centavos) {
    var pesos = Math.round(centavos / 100);
    return '$' + pesos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  var drawer = document.getElementById('shalem-cart-drawer');
  var overlay = document.getElementById('shalem-cart-overlay');
  if (!drawer || !overlay) return;

  function abrir() {
    drawer.classList.add('visible');
    overlay.classList.add('visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function cerrar() {
    drawer.classList.remove('visible');
    overlay.classList.remove('visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function obtenerCarrito() {
    var r = await fetch('/cart.js');
    return r.json();
  }

  async function agregar(id, cantidad) {
    cantidad = cantidad || 1;
    await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: cantidad }] })
    });
    var cart = await obtenerCarrito();
    render(cart);
    abrir();
    return cart;
  }

  async function cambiarLinea(linea, cantidad) {
    await fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad })
    });
    var cart = await obtenerCarrito();
    render(cart);
  }

  function iconoTacho() {
    return '<svg viewBox="0 0 16 16" fill="none" stroke="#C9B99A" stroke-width="1.5" width="16" height="16"><path d="M2 4h12M6 4V2h4v2M4 4l1 10h6l1-10" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function leerWishlist() {
    try { return JSON.parse(localStorage.getItem(LS_WISHLIST) || '[]'); } catch (e) { return []; }
  }
  function guardarEnWishlist(item) {
    var lista = leerWishlist();
    lista.push({ variant_id: item.variant_id, title: item.title, sku: item.sku, guardado: Date.now() });
    localStorage.setItem(LS_WISHLIST, JSON.stringify(lista));
  }

  function renderItems(cart) {
    var cont = document.getElementById('shalem-cart-items');
    cont.innerHTML = '';
    cart.items.forEach(function (item, i) {
      var linea = i + 1;
      var variantes = (item.options_with_values || []).map(function (o) { return o.name + ': ' + o.value; });
      var div = document.createElement('div');
      div.className = 'shalem-cart-item';
      div.innerHTML =
        '<img class="shalem-cart-item-img" src="' + (item.image || '') + '" alt="' + (item.product_title || '').replace(/"/g, '') + '" width="80" height="100" loading="lazy">' +
        '<div class="shalem-cart-item-info">' +
          '<div class="shalem-cart-item-fila1">' +
            '<p class="shalem-cart-item-nombre">' + item.product_title + '</p>' +
            '<button type="button" class="shalem-cart-item-editar">Editar</button>' +
          '</div>' +
          '<p class="shalem-cart-item-precio">' + formatoCOP(item.line_price) + '</p>' +
          '<div class="shalem-cart-item-variantes">' +
            variantes.map(function (v) { return '<p class="shalem-cart-item-variante">' + v + '</p>'; }).join('') +
          '</div>' +
          '<div class="shalem-cart-item-fila4">' +
            '<div class="shalem-cart-qty">' +
              '<button type="button" class="shalem-cart-item-borrar" aria-label="Eliminar">' + iconoTacho() + '</button>' +
              '<span class="shalem-cart-qty-num">' + item.quantity + '</span>' +
              '<button type="button" class="shalem-cart-qty-btn" data-accion="mas">+</button>' +
            '</div>' +
            '<button type="button" class="shalem-cart-item-wishlist">Mover a lista de deseos</button>' +
          '</div>' +
        '</div>';

      div.querySelector('[data-accion="mas"]').addEventListener('click', function () {
        cambiarLinea(linea, item.quantity + 1);
      });
      div.querySelector('.shalem-cart-item-borrar').addEventListener('click', function () {
        cambiarLinea(linea, item.quantity - 1 >= 0 ? item.quantity - 1 : 0);
      });
      div.querySelector('.shalem-cart-item-editar').addEventListener('click', function () {
        window.location.href = item.url || ('/products/' + PRODUCT_HANDLE);
      });
      div.querySelector('.shalem-cart-item-wishlist').addEventListener('click', function () {
        guardarEnWishlist(item);
        cambiarLinea(linea, 0);
      });

      cont.appendChild(div);
    });
  }

  function renderEnvio(cart) {
    var texto = document.getElementById('shalem-envio-texto');
    var relleno = document.getElementById('shalem-envio-relleno');
    var zona = document.getElementById('shalem-cart-envio');
    var subtotal = cart.total_price;
    if (subtotal >= UMBRAL_ENVIO) {
      zona.classList.add('shalem-envio-completo');
      texto.textContent = '✓ ¡Tienes envío GRATIS a Colombia!';
      relleno.style.width = '100%';
    } else {
      zona.classList.remove('shalem-envio-completo');
      var falta = UMBRAL_ENVIO - subtotal;
      texto.textContent = 'Agrega ' + formatoCOP(falta) + ' más y obtén envío GRATIS 🚚';
      var pct = Math.min(100, (subtotal / UMBRAL_ENVIO) * 100);
      relleno.style.width = pct + '%';
    }
  }

  var productoCache = null;
  async function obtenerProducto() {
    if (productoCache) return productoCache;
    var r = await fetch('/products/' + PRODUCT_HANDLE + '.js');
    productoCache = await r.json();
    return productoCache;
  }

  async function renderResumen(cart) {
    document.getElementById('shalem-cart-badge').textContent = '(' + cart.item_count + ')';
    var vacio = document.getElementById('shalem-cart-vacio');
    var resumen = document.getElementById('shalem-cart-resumen');
    var itemsCont = document.getElementById('shalem-cart-items');
    var envioZona = document.getElementById('shalem-cart-envio');
    var addonZona = document.getElementById('shalem-addon');
    var fbtZona = document.querySelector('.shalem-fbt');
    var promoZona = document.getElementById('shalem-promo');
    var politicasZona = document.querySelector('.shalem-politicas');

    if (cart.item_count === 0) {
      vacio.hidden = false;
      resumen.style.display = 'none';
      itemsCont.style.display = 'none';
      envioZona.style.display = 'none';
      if (addonZona) addonZona.style.display = 'none';
      if (fbtZona) fbtZona.style.display = 'none';
      if (promoZona) promoZona.style.display = 'none';
      if (politicasZona) politicasZona.style.display = 'none';
      return;
    }
    vacio.hidden = true;
    resumen.style.display = '';
    itemsCont.style.display = '';
    envioZona.style.display = '';
    if (addonZona) addonZona.style.display = '';
    if (fbtZona) fbtZona.style.display = '';
    if (promoZona) promoZona.style.display = '';
    if (politicasZona) politicasZona.style.display = '';

    document.getElementById('shalem-cart-subtotal').textContent = formatoCOP(cart.total_price);

    var ahorro = 0;
    try {
      var producto = await obtenerProducto();
      ahorro = cart.items.reduce(function (a, i) {
        var v = producto.variants.find(function (vv) { return vv.id === i.variant_id; });
        if (v && v.compare_at_price && v.compare_at_price > v.price) {
          return a + (v.compare_at_price - v.price) * i.quantity;
        }
        return a;
      }, 0);
    } catch (e) {}
    var ahorroFila = document.getElementById('shalem-cart-ahorro-fila');
    if (ahorro > 0) {
      ahorroFila.hidden = false;
      document.getElementById('shalem-cart-ahorro').textContent = formatoCOP(ahorro);
    } else {
      ahorroFila.hidden = true;
    }

    var envioEstado = document.getElementById('shalem-cart-envio-estado');
    if (cart.total_price >= UMBRAL_ENVIO) {
      envioEstado.textContent = 'GRATIS';
      envioEstado.classList.add('shalem-envio-gratis-texto');
    } else {
      envioEstado.textContent = 'Calculado al checkout';
      envioEstado.classList.remove('shalem-envio-gratis-texto');
    }

    document.getElementById('shalem-cart-total').textContent = formatoCOP(cart.total_price);
    document.getElementById('shalem-cart-checkout-precio').textContent = formatoCOP(cart.total_price);
  }

  function render(cart) {
    renderItems(cart);
    renderEnvio(cart);
    renderResumen(cart);
  }

  document.getElementById('shalem-cart-cerrar').addEventListener('click', cerrar);
  overlay.addEventListener('click', cerrar);
  document.getElementById('shalem-cart-seguir').addEventListener('click', cerrar);
  document.getElementById('shalem-cart-checkout').addEventListener('click', function () {
    window.location.href = '/checkout';
  });
  document.getElementById('shalem-vacio-btn').addEventListener('click', function () {
    cerrar();
    var hero = document.querySelector('.shalem-producto') || document.querySelector('[data-shalem-target-fragancia]');
    if (hero) {
      hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.location.href = '/products/' + PRODUCT_HANDLE;
    }
  });

  var addonCheckbox = document.getElementById('shalem-addon-checkbox');
  if (addonCheckbox) {
    addonCheckbox.addEventListener('change', function () {
      var nota = addonCheckbox.checked ? 'Incluir muestra gratis: sí' : '';
      fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: nota })
      });
    });
  }

  document.querySelectorAll('.shalem-fbt-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.textContent = '✓';
      setTimeout(function () { btn.textContent = '+'; }, 1200);
    });
  });

  var promoHeader = document.querySelector('.shalem-promo-header');
  if (promoHeader) {
    promoHeader.addEventListener('click', function () {
      var promo = document.getElementById('shalem-promo');
      var body = document.getElementById('shalem-promo-body') || promo.querySelector('.shalem-promo-body');
      var abierto = promo.classList.contains('open');
      promo.classList.toggle('open', !abierto);
      body.hidden = abierto;
    });
  }
  var promoAplicar = document.getElementById('shalem-promo-aplicar');
  if (promoAplicar) {
    promoAplicar.addEventListener('click', function () {
      var input = document.getElementById('shalem-promo-input');
      var msg = document.getElementById('shalem-promo-msg');
      var codigo = (input.value || '').trim();
      if (!codigo) return;
      fetch('/discount/' + encodeURIComponent(codigo)).catch(function () {});
      msg.hidden = false;
      msg.textContent = 'Código "' + codigo + '" se aplicará en el checkout.';
    });
  }

  document.querySelectorAll('.policy-header').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.policy-item');
      var isOpen = item.classList.contains('open');

      document.querySelectorAll('.policy-item').forEach(function (i) {
        i.classList.remove('open');
      });

      if (!isOpen) {
        item.classList.add('open');
      }
    });
  });

  var cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      obtenerCarrito().then(render);
      abrir();
    });
  }

  window.ShalemCart = {
    abrir: abrir,
    cerrar: cerrar,
    agregar: agregar,
    refrescar: function () { return obtenerCarrito().then(render); }
  };

  obtenerCarrito().then(render);
})();
